import { useTranslation } from '@presentation/utils';
import { useFormikContext } from 'formik';
import type { FC, PropsWithChildren } from 'react';
import { FaSlidersH } from 'react-icons/fa';
import type { InputSelectFieldProps } from '..';
import { Button, InputSelectField, ModalWithCard } from '..';
import type { InputWrapperProps } from '../InputWrapper/types';
import * as Styled from './styled';
import type { FiltersWithModalProps } from './types';

export * from './types';

export const FiltersWithModal: FC<FiltersWithModalProps> = (props) => {
  const { modal, onShowClick, onResetClick, canReset, loading, children } = props;
  const { translate } = useTranslation();

  return (
    <>
      <ModalWithCard modalProps={modal}>
        {children}
        <Styled.MobileButtonContainer>
          <Button outlined color="blue" onClick={onResetClick} shrink disabled={!canReset}>
            {translate('common.buttons.reset')}
          </Button>
          <Button
            color="blue"
            loading={loading}
            onClick={() => {
              modal.onCloseClick?.();
            }}
          >
            {translate('common.buttons.showSearch')}
          </Button>
        </Styled.MobileButtonContainer>
      </ModalWithCard>
      <Styled.MoreFiltersButton
        color="blue"
        outlined
        onClick={onShowClick}
        iconLeft={<FaSlidersH />}
      >
        {translate('common.buttons.filter')}
      </Styled.MoreFiltersButton>
      <Styled.ChildrenWrapper>{children}</Styled.ChildrenWrapper>
    </>
  );
};

export const FiltersWithModalInputWrapper: FC<InputWrapperProps> = (props) => {
  const { children, ...rest } = props;

  return (
    <Styled.StyledInputWrapper fullWidthBreakpoint="tablet" width="200px" inline {...rest}>
      {children}
    </Styled.StyledInputWrapper>
  );
};

export const FiltersWithModalInputSelectField = <TValue,>(
  props: PropsWithChildren<InputSelectFieldProps<TValue>>,
) => {
  const { children, ...rest } = props;
  const { submitForm } = useFormikContext();

  return (
    <InputSelectField
      hasDropdownIcon
      clearButton={{
        showOnNotEmpty: true,
        onClear: () => submitForm(),
      }}
      onSelect={() => {
        submitForm();
      }}
      {...rest}
    >
      {children}
    </InputSelectField>
  );
};
